import { Route } from '@angular/router';
import { HomeComponent, SearchComponent, ContactComponent, CmsPage, PrivacyAndCookiePolicyComponent, CustomizeGuidelinesComponent } from './components';

const FIXED_PATHS: Route[] = [
  {
    path: 'search',
    component: SearchComponent,
  },
  {
    path: 'contact',
    component: ContactComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyAndCookiePolicyComponent,
    data: {
      metaUrl: 'privacy-policy'
    }
  },
  {
    path: 'cookie-policy',
    component: PrivacyAndCookiePolicyComponent,
    data: {
      metaUrl: 'cookie-policy'
    }
  }
];

export const appRoutes: Route[] = [
  {
    path: ':lang',
    children: [
      ...FIXED_PATHS,
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: ':first',
        component: CmsPage,
      },
      {
        path: ':first/:second',
        component: CmsPage,
      },
      {
        path: ':first/:second/:third',
        component: CmsPage,
      },

      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: 'en',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'en',
  },
];
